import { useQuery } from '@tanstack/react-query';
import { useAuthStore, type User } from '@/stores/auth.store';
import api from '@/lib/api';

export function useAuth() {
  const { user, token, isAuthenticated, login, logout, setUser } = useAuthStore();

  const meQuery = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async (): Promise<User> => {
      const { data: resp } = await api.get('/auth/me');
      // Axios .data → { success, data: { id, email, ... }, meta }
      // TransformInterceptor wraps the AuthUser directly in .data (no .user wrapper)
      const u = resp.data as User;
      setUser(u);
      return u;
    },
    enabled: !!token,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false,
  });

  return {
    user: user ?? meQuery.data ?? null,
    isAuthenticated,
    isLoading: meQuery.isLoading && !!token,
    login,
    logout,
  };
}
